import axios from "axios";
import toast from "react-hot-toast";

// Base Axios instance
const apiClient = axios.create({
  baseURL: "https://headquater.pixoatic.com/api/v1", // Base URL for your API
  headers: { "Content-Type": "application/json" },
});

// Request Interceptor for Adding Token
apiClient.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem("authToken");
    const canteenToken = localStorage.getItem("canteenToken");
    const canteenId = localStorage.getItem("canteenId");

    if (canteenId && canteenToken) {
      console.log("canteenId", canteenId, canteenToken);

      config.headers["token"] = canteenToken;
    } else if (authToken) {
      config.headers["token"] = authToken;
    } else {
      delete config.headers["token"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor for Handling Expired Token
apiClient.interceptors.response.use(
  (response) => response,
  (errors) => {
    console.log("iiiiiiiiiii", errors.response);

    if (errors.response) {
      const { status, data } = errors.response;

      const isInvalidToken =
        Array.isArray(data?.errors) &&
        data.errors.some(
          (err) =>
            err.token === "Invalid token" || err.token === "Token has Expired"
        );

      const canteenId = localStorage.getItem("canteenId");

      if ((status === 401 || status === 400) && isInvalidToken) {
        if (canteenId) {
          // Clear only canteen token
          localStorage.removeItem("canteenToken");
        } else {
          localStorage.removeItem("authToken");
          localStorage.removeItem("userName");
          localStorage.removeItem("userType");
          localStorage.removeItem("userId");
        }

        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      }
    }
    return Promise.reject(errors);
  }
);

let lastErrorMessage = "";
let lastShownTime = 0;

export const handleError = (errors) => {
  const now = Date.now();
  // const errorMsg = errors?.response?.data?.errors

  const showToast = (msg) => {
    if (msg !== lastErrorMessage || now - lastShownTime > 3000) {
      toast.error(msg, { duration: 2000 });
      lastErrorMessage = msg;
      lastShownTime = now;
    }
  };

  if (errors?.response) {
    const { status, data } = errors.response;
    console.log("data", data);

    switch (status) {
      case 404:
        toast.error(data.errors || errors.response.statusText, {
          duration: 2000,
        });

        break;

      case 400:
        if (data.errors?.length) {
          showToast(data.errors[0].token, { duration: 1000 });
        }
        break;
      case 403:
        showToast(data.errors);
        break;

      case 401:
        if (Array.isArray(data.errors)) {
          showToast(data.errors[0]?.token, { duration: 1000 });
        } else if (typeof data.errors === "object") {
          const errorMsg = Object.values(data.errors)[0];
          showToast(errorMsg, { duration: 1000 });
        } else {
          showToast(data.errors, { duration: 1000 });
        }
        break;

      case 422:
        if (data?.errors) {
          if (Array.isArray(data.errors)) {
            data.errors.forEach((msg) => toast.error(msg, { duration: 2000 }));
          } else {
            toast.error(data.errors, { duration: 2000 });
          }
        }
        break;

      case 500:
        showToast("Internal Server Error. Please try again later.", {
          duration: 2000,
        });
        break;

      default:
        toast.error("An unexpected error occurred.", { duration: 2000 });
    }
  } else if (errors?.message === "Network Error") {
    showToast("Network error. Please check your connection and try again."); // for a network error
  }
};

const apiService = {
  // GET Request
  get: async (endpoint, params = {}) => {
    try {
      const response = await apiClient.get(endpoint, { params });
      return response.data;
    } catch (errors) {
      if (errors?.response?.status !== 404) {
        handleError(errors);
      }
      return null;
    }
  },

  post: async (endpoint, data = {}, config = {}) => {
    try {
      const isFormData = data instanceof FormData;
      console.log("data", data);

      const headers = isFormData
        ? { "Content-Type": "multipart/form-data" }
        : {};

      const response = await apiClient.post(endpoint, data, {
        ...config,
        headers: {
          ...headers,
          ...(config.headers || {}),
        },
      });
      if (isFormData) {
        return response;
      }
      if (config?.responseType === "blob") {
        return response;
      }

      return response.data;
    } catch (errors) {
      handleError(errors);
       throw errors;
    }
  },
  // PUT Request
  put: async (endpoint, data = {}) => {
    try {
      const headers =
        data instanceof FormData
          ? { "Content-Type": "multipart/form-data" }
          : {};

      const response = await apiClient.put(endpoint, data, { headers });
      return response.data;
    } catch (errors) {
      return handleError(errors);
    }
  },

  // patch request
  patch: async (endpoint, data = {}) => {
    try {
      const headers =
        data instanceof FormData
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" }; // Assuming JSON as default

      const response = await apiClient.patch(endpoint, data, { headers });
      return response.data;
    } catch (errors) {
      return handleError(errors);
    }
  },

  // DELETE Request
  delete: async (endpoint) => {
    try {
      const response = await apiClient.delete(endpoint);
      return response.data;
    } catch (errors) {
      return handleError(errors);
    }
  },

  // Convert 24-hour time format to 12-hour format
  convert24To12Hr: (time24) => {
    let [hours, minutes] = time24?.split(":");
    hours = parseInt(hours, 10);
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${String(hours).padStart(2, "0")}:${minutes} ${period}`;
  },

  // Convert 12-hour time format to 24-hour format
  convert12To24Hr: (time12) => {
    const [time, period] = time12?.split(" ");
    let [hours, minutes] = time?.split(":");
    hours = parseInt(hours, 10);
    if (period === "PM" && hours < 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }
    return `${String(hours).padStart(2, "0")}:${minutes}`;
  },
};

export const formatRupees = (amount) => `₹ ${Math.trunc(amount)}`;

export default apiService;
